<template>
  <v-textarea
    :rows="2"
    counter="1000"
    filled
    class="questionText"
    v-model.trim="text"
    :label="labelText"
    :disabled="disabled"
    :max="1000"
    maxlength="1000"
    :rules="
      !isSubtitle
        ? [
            (v) =>
              !!(v ? v.trim() : '') ||
              (requiredMessage != null
                ? requiredMessage
                : $t('widget.fieldRequired')),
            (v) =>
              regExp.test(v) ||
              (validationMessage != null ? validationMessage : $t('widget.fieldInvalid')),
              (v) => v.length <= 1000 || this.$t('ruleQuestionMaxLength')
          ]
        : []
    "
    :required="!isSubtitle"
  ></v-textarea>
</template>

<script>
export default {
  name: "QuestionText",
  props: {
    requiredMessage: {
      type: String,
      // default: this.$t("msgQuestionRequired"),
      default: ""
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSubtitle: {
      type: Boolean,
      default: false,
    },
    regExp: {
      type: RegExp,
      //default: () => /[a-zA-Z]/,
      default: () => /[一-龠ぁ-ゔァ-ヴーa-zA-Zａ-ｚＡ-Ｚ々〆〤]/,
    },
    validationMessage: {
      type: String,
      default: null,
    },
  },
  computed: {
    labelText() {
      return this.label === "" ? this.$t("poll.lblSurveyQuestion") : this.label;
    },
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
  },
  methods: {
    textValidation(){

    }
  }
};
</script>

<style scoped>
.questionText {
  font-family: 'Noto Sans JP' !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  min-height: 48px !important;
  /* max-height: 68px !important; */
  color: var(--v-neutralGray-base) !important;  
  align-items: center !important;
}
.questionText > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
  height: 48px !important;
}
.questionText /deep/ .v-input__slot {
  min-height: 48px !important;
}
.v-text-field--filled {
  border-radius: 0px !important;
}
</style>